import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 823;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4SSt4d09sd2VOSjg4WkF5WUZtTS9rTT0=';
    clientId: string = 'eea4a8f9-a2e6-4453-8e16-62c9b66fa259-823';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();